import React from 'react';
import { BuilderNumberInputField } from '../../../BuilderFields';
import { SimpleCohortTypeKey } from '../../../../../utils/apollo/graphqlSchema';
import {
  IRowMeta,
  setCohortRowOperatorValues,
  setCohortRowTimeToConvertOperatorValues,
} from '../../../../../redux/slices/oldBuilder';
import { useAppDispatch } from '../../../../../redux/hooks';
import { getCohortOperatorValuePrecision } from '../utils';
import { useCohortRowContext } from '../CohortRowContext';

interface IProps {
  simpleCohortTypeKey: SimpleCohortTypeKey;
  rowMeta: IRowMeta & {
    // numberIndex is required for this component to work properly
    numberIndex: number;
  };
  value: number | null;
}

const CohortRowOperatorValue = ({
  simpleCohortTypeKey,
  rowMeta,
  value,
}: IProps) => {
  const dispatch = useAppDispatch();
  const { isTimeToConvertRow } = useCohortRowContext();

  const handleChangeOperatorValue = (newValue: number | null) => {
    if (isTimeToConvertRow) {
      dispatch(
        setCohortRowTimeToConvertOperatorValues({
          newValue,
          rowMeta,
        }),
      );
    } else {
      dispatch(
        setCohortRowOperatorValues({
          newValue,
          rowMeta,
        }),
      );
    }
  };

  const precision = getCohortOperatorValuePrecision(simpleCohortTypeKey);

  return (
    <BuilderNumberInputField
      placeholder="eg. 5"
      precision={precision}
      value={value}
      onChange={handleChangeOperatorValue}
      rowMeta={rowMeta}
      errorKey={isTimeToConvertRow ? 'ttcOperatorValues' : 'operatorValues'}
    />
  );
};

export default CohortRowOperatorValue;
